export const getters = {
  getJoinableProjects: (state, _getters, rootState) => {
    const orgId = parseInt(rootState.org.selectedOrg)
    return state.joinableProjects.filter(
      p => p.organization_id === orgId && !state.flatedProjects.some(m => m.project_id === p.project_id)
    )
  },
  getProjects: state => {
    return state.projects
  },
  getFlatedProjects: state => {
    return state.flatedProjects
  },
  current: state => {
    return state.current
  },
  isMonitoringEnabled: state => projectId => {
    const id = parseInt(projectId)
    if (!id) return true

    if (state.current && state.current.project_id === id) {
      return !!state.current.monitoring_enabled
    }

    const project = (state.flatedProjects || []).find(p => p.project_id === id)
    // Fail open for projects we have no payload for — the API is the authority
    // and rejects unmonitorable projects with a warning header.
    return project ? !!project.monitoring_enabled : true
  },
  getLastSelected: state => {
    return state.lastSelected
  },
  getSelected: state => {
    return state.selected
  },

  // Components
  getComponents: state => {
    return state.components
  },
  getAllComponents: state => {
    return state.allComponents
  },

  // Project Invites
  getMemberInvites: state => {
    return state.memberInvites
  },
  getInvites: state => {
    return state.invites
  },
  getAllInvites: state => {
    return state.allInvites
  },

  // Project members
  getCurrentMember: state => {
    return state.currentMember
  },
  getMembers: state => {
    return state.members
  },
  getAllMembers: state => {
    return state.allMembers
  },
  getMembersCount: state => {
    return state.membersCount
  },

  // Tags
  getCurrentTags: state => {
    return state.currentTags
  },

  getAllTags: state => {
    return state.allTags
  },

  // Countries
  getGroups: state => {
    return state.groups
  },
  getCurrentRegion: state => {
    return state.currentRegion
  },

  // Planet
  getPlanetFeatures: state => {
    return state.planetFeatures
  },

  getShowProjectForm: state => {
    return state.showProjectForm
  },
  getProjectFormContext: state => {
    return state.projectFormContext
  },

  getIsLoading: state => {
    return state.isLoading
  }
}
